.content {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px 24px 40px;
  overflow-y: auto;
  background: var(--bg-page, #fff);
}
